import React, { FC, ReactNode } from 'react';
import { RuleSet } from 'styled-components';
import Footer from '../Footer';
import SkipToContent from '../SkipToContent';
import * as S from './styles';

interface PageProps {
  header?: ReactNode;
  footerStyle?: 'none' | 'full';
  children?: ReactNode;
  contentBackground?: RuleSet<object>;
}

const Page: FC<PageProps> = ({ children, header, footerStyle = 'full', contentBackground }) => {
  return (
    <S.PageContainer>
      <SkipToContent />
      {header}
      <S.PageContent id="main-content" $background={contentBackground}>
        {children}
      </S.PageContent>
      {footerStyle !== 'none' && <Footer />}
    </S.PageContainer>
  );
};

export default Page;
